import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AddComponentsComponent } from '../add-components/add-components.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { ComponentsService } from '../../../services/api/components.service';
import { pipe } from 'rxjs/internal/util/pipe';
import { MatTableDataSource } from '@angular/material/table';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import cloneDeep from 'lodash/cloneDeep';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permission, Permissions } from 'src/app/models/principal/permission';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { PermissionService } from 'src/app/services/api/permission.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Router} from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.SOLUTION_READ,
    action: Permissions.SOLUTION_READ
  },
  {
    key: PermissionKeys.SOLUTION_CREATE,
    action: Permissions.SOLUTION_CREATE
  },
];

@Component({
    selector: 'app-components-list',
    templateUrl: './components-list.component.html',
    styleUrls: ['./components-list.component.scss'],
    standalone: false
})
export class ComponentsListComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  breadcrumbItems: BreadcrumbItem[];
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  displayedColumns: string[] = ['name', 'displayName', 'version', 'type', 'createdOn', 'updatedOn', 'actions'];
  componentsData: any;
  dataSource: any;
  showSpinner = true;
  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  isReader: boolean;
  searchText: string;
  defaultComponents: any;
  isFailed = false;
  PermissionKeys= PermissionKeys;

  constructor(private sidenavService: SidenavService, private toastrService: ToastrService,
    private componentsService: ComponentsService, private dialog: MatDialog, private customToastrService: CustomToastrService, private permissionsService: PermissionsService, private permissionService: PermissionService,
    private router: Router, public authService: AuthService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.SOLUTION_READ]) {
      this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.COMPONENTS';
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ icon: 'home' },
      { label: translate('LEFT_SIDE_NAV.SOLUTION_ONBOARDING') },
      { label: translate('LEFT_SIDE_NAV.COMPONENTS'), url: ['components'] });
     this.getComponents();
    }

    getComponents(): void {
      this.showSpinner = true;
      this.isFailed = false;
      this.componentsData = [];
      this.loadData(this.componentsData);
      this.componentsService.getComponents()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if(data) {
          this.componentsData = data;
          this.defaultComponents = data;
          this.loadData(this.componentsData);
          this.showSpinner = false;
        }
      },
      (error) => {
        this.showSpinner = false;
        this.isFailed = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.customToastrService.errMessage(message, title);
        }, 500);
      }
      );
    }


  sortData(event): void {
    this.sortInfo = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.componentsData = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.componentsData?.slice(this.pageIndex, this.paginationSize));
  }

  loadData(data?): void {
    this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.dataSource = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    }
  }

  sortInstanceData(event): any {
    return this.componentsData?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'name':
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
        case 'displayName':
          comparatorResult = a?.displayName && b?.displayName ? a?.displayName?.localeCompare(b?.displayName) : !a?.displayName ? -1 : 1;
          break;
        case 'version':
          comparatorResult = a?.tagline && b?.version ? a?.version?.localeCompare(b?.version)
            : !a?.tagline ? -1 : 1;
          break;
        case 'type':
          comparatorResult = a?.type && b?.type ? a?.type?.localeCompare(b?.type)
            : !a?.type ? -1 : 1;
          break;
        case 'createdOn':
          comparatorResult = a?.createdOn && b?.createdOn ? a?.createdOn?.localeCompare(b?.createdOn)
            : !a?.createdOn ? -1 : 1;
          break;
        case 'updatedOn':
          comparatorResult = a?.updatedOn &&
            b?.updatedOn ? a?.updatedOn?.toString()?.localeCompare(b?.updatedOn?.toString())
            : !a?.updatedOn ? -1 : 1;
          break;
        default:
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.componentsData.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  addNewComponent(): void {
    this.sidenavService.openInRightSidenav(AddComponentsComponent)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((formData) => {
      if (!formData) {
        return;
      }
    });
  }

  deleteComponent(data): void {
    if (!this.permissionsMap[PermissionKeys.SOLUTION_CREATE]) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });  
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('COMPONENTS.TITLE'),
          message: translate('COMPONENTS.MESSAGE'),
          confirmButtonText: translate('BUTTONS.DELETE')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.componentsService.deleteComponent(data.name, data.version)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((res) => {
                if (res) {
                  setTimeout(() => {
                    const message = translate('INSTANCE_DETAILS.COMPONENT_DELETED');
                    const title = translate('INSTANCE_DETAILS.COMPONENT');
                    this.customToastrService.successMessage(message, title);
                }, 500);
                }
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',width: '630px',panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.DELETE_COMPONENT_FAILED'),
                    description: errorMessage}
                  });
              });
          }
        });
    }
  }

  editComponent(data): void {
    if (!this.permissionsMap[PermissionKeys.SOLUTION_CREATE]) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });  
    } else {
      const editData = cloneDeep(data);
      this.sidenavService.openInRightSidenav(AddComponentsComponent, { editData, edit: true })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((dataForm) => {
          if (!dataForm) {
            return;
          }
        });
    }
  }

  searchSolution(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.componentsData = this.defaultComponents;
    if (this.searchText) {
      this.componentsData = this.componentsData.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.componentsData = this.defaultComponents;
    }
    const data = this.componentsData.slice(this.pageIndex, this.paginationSize);
    this.dataSource = new MatTableDataSource(data);
  }

}


